import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getcreditlimitbymode } from "../store/User/CreditLimitSlice";

const OCEAN_CARGO_TYPE = "Ocean Cargo";

/**
 * Calls POST /credit_limit for the logged-in user and the current search's
 * mode, and logs the response to the console.
 *
 * userid comes from /user-details (loaded into `state.data` by PageLayout), so
 * the call waits until that has resolved. mode follows the stored search:
 * an "Ocean Cargo" search is ocean, everything else is air.
 *
 * @param {Object}  [options]
 * @param {boolean} [options.enabled=true] - skip the call while false (e.g. a closed modal)
 * @param {string}  [options.cargoType] - overrides the stored search's cargoType
 */
const useLogCreditLimit = ({ enabled = true, cargoType } = {}) => {
  const dispatch = useDispatch();
  const userid = useSelector((state) => state.data?.data?.data?.user?.id);
  const storedCargoType = useSelector(
    (state) => state.newsearchform?.newsearchformdata?.searchquery?.cargoType
  );
  const mode =
    (cargoType ?? storedCargoType) === OCEAN_CARGO_TYPE ? "ocean" : "air";

  useEffect(() => {
    if (!enabled || !userid) return;
    dispatch(getcreditlimitbymode({ mode, userid })).then((res) => {
      console.log("creditlimit", res?.payload?.data?.data?.creditlimit);
    });
  }, [enabled, userid, mode, dispatch]);
};

export default useLogCreditLimit;
